import React from 'react';
import PropTypes from 'prop-types';
import { Divider, Grid, Header } from "../..";

/**
 * Title of section item.
 *
 * @param {*} props
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SectionItemTitle = function SectionItemTitle(props) {
  var _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title,
    renderer = props.renderer;
  return /*#__PURE__*/_jsx(Grid, {
    className: "section",
    style: {
      marginLeft: 0
    },
    children: /*#__PURE__*/_jsxs(Grid.Column, {
      children: [/*#__PURE__*/_jsx(Grid.Row, {
        style: {
          paddingBottom: 0
        },
        children: renderer ? renderer() : /*#__PURE__*/_jsx(Header, {
          size: "small",
          style: {
            margin: 0
          },
          children: title
        })
      }), /*#__PURE__*/_jsx(Grid.Row, {
        style: {
          padding: 0
        },
        children: /*#__PURE__*/_jsx(Grid.Column, {
          children: /*#__PURE__*/_jsx(Divider, {
            style: {
              marginTop: 4,
              borderTopWidth: 2,
              borderTopColor: 'red'
            }
          })
        })
      })]
    })
  });
};

/** Proptypes. */
SectionItemTitle.handledProps = ["renderer", "title"];
SectionItemTitle.propTypes = {
  /** Text to display. */
  title: PropTypes.string,
  /** Custom renderer. */
  renderer: PropTypes.func
};
export default SectionItemTitle;